import { UserInfo } from 'firebase/auth';
import { UserActionTypes } from '@bridebook/web/lib/users/action-types';

export const saveUserProvider = (provider: UserInfo) => ({
  type: UserActionTypes.SAVE_USER_PROVIDER,
  payload: provider,
});
